export default __webpack_public_path__ + "static/Plots0001-fbd4faba2cb3d1a8b4b595b6cdc73f4b.jpg";